/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
});

export const GetCluster = {
  id: 'cluster.get',
  tag: 'Cluster',
  summary: 'Get cluster',
  description: 'Retrieve a cluster within an organization project',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            id: ZodTypes.Id,
            type: ZodTypes.ServiceType,
            name: z.string().min(1),
            description: z.string().min(1).nullable().optional(),
            createdAt: z.date(),
            updatedAt: z.date(),
            configuration: z.array(
              z.strictObject({
                id: ZodTypes.Id,
                createdAt: z.date(),
                replicas: z.number().min(0),
                endedAt: z.date().or(z.literal('infinity')),
                cpuUnits: z.number().min(0),
                memoryGbs: z.number().min(0),
                storageGbs: z.number().min(0),
                postgresVersion: z.number().min(0),
                storageClassId: z.string().min(1),
                supportPlan: z.strictObject({
                  id: ZodTypes.Id,
                  name: z.string().min(1),
                  description: z.string().min(1),
                  isDefault: z.boolean(),
                  price: z.number(),
                }),
                storageClass: z.strictObject({
                  id: z.string().min(1),
                  isDefault: z.boolean(),
                }),
              }),
            ),
            isCloning: z.boolean(),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
